module.exports = __webpack_public_path__ + "static/media/projects.511a6da0.png";